import React from 'react';
import { Cell, Pie, PieChart, Tooltip } from 'recharts';

const COLORS = [
  '#b39ddb', // < 1 año
  '#9575cd', // Entre 1 y 4 años
  '#7986cb', // Entre 5 y 8 años
  '#4fc3f7' // > 8 años
];

const GroupByAntiquityGraph = ({ title = {} }) => {
  const data = [
    { name: '< 1 año', value: title.lessThanOneYear },
    { name: 'Entre 1 y 4 años', value: title.betweenOneAndFourYears },
    { name: 'Entre 5 y 8 años', value: title.betweenFiveAndEightYears },
    { name: '> 8 años', value: title.moreThanEightYears }
  ];

  return (
    <div style={{ display: 'flex', alignItems: 'center', width: '100%' }} className="mt-3">
      <PieChart width={70} height={70}>
        <Pie
          data={data}
          cx="50%"
          cy="50%"
          innerRadius={22}
          outerRadius={32}
          dataKey="value"
          startAngle={90}
          endAngle={-270}
          paddingAngle={2}
        >
          {data.map((entry, index) => (
            <Cell key={`cell-${entry.name}`} fill={COLORS[index % COLORS.length]} />
          ))}
        </Pie>
        <Tooltip />
      </PieChart>
      <div style={{ marginLeft: 30 }}>
        {data.map((entry, index) => (
          <div
            key={entry.name}
            style={{
              display: 'flex',
              alignItems: 'center',
              marginBottom: 2
            }}
          >
            <span
              style={{
                display: 'inline-block',
                width: 9,
                height: 9,
                backgroundColor: COLORS[index % COLORS.length],
                borderRadius: '50%',
                marginRight: 6
              }}
            />
            <span style={{ color: '#757575', fontSize: 10 }}>{entry.name}</span>
          </div>
        ))}
      </div>
    </div>
  );
};
export default GroupByAntiquityGraph;
